"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PrimusPreviewSection = _interopRequireDefault(require("./PrimusPreviewSection"));

var _LayoutSection = _interopRequireDefault(require("../../Section/LayoutSection"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {}
}));

const PrimusSection = props => {
  const formContext = props.formContext;
  const classes = useStyles();

  if (props.field && props.field === "primusChildren") {
    return _react.default.createElement(_LayoutSection.default, props);
  }

  const primaryAction = formContext.primaryAction && formContext.primaryAction.type && formContext.primaryAction.type;

  if (primaryAction === "edit" || primaryAction === "view") {
    return _react.default.createElement(_PrimusPreviewSection.default, props);
  } // buttons


  const id = props.id,
        step = props.step,
        nextId = props.nextId,
        nextStep = props.nextStep,
        nextAction = props.nextAction;
  const status = formContext.status,
        currentId = formContext.currentId,
        onStep = formContext.onStep;
  let buttons = props.buttons || [];

  if (status === "steps" && currentId === id && nextId) {
    onStep({
      id: id,
      step: step
    });
    buttons.push({
      "icon": "check",
      "label": "Lagre og gå videre",
      "variant": "contained",
      "color": "primary",
      "onClick": () => onStep({
        id: nextId,
        step: nextStep
      })
    });
  } else if (status === "steps" && currentId === id && nextAction) {
    onStep({
      id: id,
      step: step
    });
    buttons.push({
      "icon": "check",
      "label": "Lagre og avslutt",
      "variant": "contained",
      "color": "primary",
      "onClick": () => onStep({
        action: nextAction
      })
    });
  }

  return _react.default.createElement("div", {
    className: classes.root,
    "aria-expanded": props.expanded
  }, _react.default.createElement(_LayoutSection.default, _extends({}, props, {
    buttons: buttons
  })));
};

var _default = PrimusSection;
exports.default = _default;
module.exports = exports.default;